import {Component, EventEmitter, Input, Output, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {NotificationService} from '../../services/notification.service';
import {Observable} from 'rxjs';
import {UserService} from '../../services/user.service';
import {environment} from '../../../environments/environment';
import {CookieService} from "ngx-cookie-service";
import {LogementService} from "../../services/logement.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent {

  public envName = environment.envName;

  public previsualisation;

  public isMCS = false;

  public logoUrl: string | null = null;

  @Output()
  onToggleMenu = new EventEmitter();

  @Input()
  showHeaders = false;

  constructor(
    private notificationService: NotificationService,
    private userService: UserService,
    private cookieService: CookieService,
    private logementService: LogementService,
  ) {
  }

  onShowHeaders(): void {
    this.previsualisation = window.self !== window.top;
    this.notificationService.load();
    this.userService.load().then((user) => {
      this.logementService.loadAndSetDefaultLogementCourant().then(l => {
        this.logoUrl = this.cookieService.get('logoParnter');
      });
      if (user.isMCS()) {
        this.isMCS = true;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showHeaders.currentValue) {
      this.onShowHeaders();
    }
  }

  toggleMenu() {
    this.onToggleMenu.emit();
  }

  get notificationsCount(): Observable<number> {
    return this.notificationService.countUnread();
  }

}
